import type { User } from '../models/user';
import type { UserRole } from '../models/auth';
import { roles as ROLE_ORDER } from '../models/auth';

export const hasRole = (
  user: User,
  role: UserRole,
  orgId?: string,
  branchId?: string,
) => {
  const userRoles = user.roles || [];
  const index = ROLE_ORDER.indexOf(role);
  const roles = ROLE_ORDER.slice(0, index + 1);

  return userRoles.some((userRole) => {
    // Check if role matches
    if (!roles.includes(userRole.role)) return false;

    // If organisationId is specified, check it matches
    if (orgId && userRole.organisation !== orgId) return false;

    // If staff member is on org level, they have access to all shops
    if (userRole.role !== 'customer' && userRole.shops.length === 0)
      return true;

    // If shopId is specified, check it matches
    if (branchId && !userRole.shops.includes(branchId)) return false;

    return true;
  });
};

/**
 * Org-WIDE variant of `hasRole`: true only when the user holds the role (or
 * higher) in an org-wide role (`shops` empty) — a branch-scoped role never
 * qualifies. Mirrors the backend `assertOrgWideRole` grant guard (#102) so the
 * client only offers org-level actions to genuine org-wide admins.
 */
export const hasOrgWideRole = (user: User, role: UserRole, orgId?: string) => {
  const userRoles = user.roles || [];
  const index = ROLE_ORDER.indexOf(role);
  const acceptable = ROLE_ORDER.slice(0, index + 1);

  return userRoles.some((userRole) => {
    if (!acceptable.includes(userRole.role)) return false;
    if (orgId && userRole.organisation !== orgId) return false;
    return userRole.role !== 'customer' && userRole.shops.length === 0;
  });
};
